

const Button = (button) => {
    const tooltip = button.dataset && button.dataset.tip || null

    const handleClick = (event) => {
        if (typeof button.onClick == "function") {
            button.onClick(event)
        }
    }

    return (
        <button
            data-tip={tooltip}
            onClick={handleClick}
            className={button.className}
        >
            {button.icon}
            {button.label}
        </button>
    )
}

export default Button;